import { getSosRequestsFilter } from '~/services/localStorage/filters';
import { SortDirection } from '~/ui/pages/Reports/constants/visitsSortOptions';
import { ISosRequestsStore } from './types';

const initStore: ISosRequestsStore = {
  current: null,
  list: [],
  pagination: {
    total: 0,
    pageNumber: 1,
    pageSize: 25,
  },
  filters: getSosRequestsFilter() || {
    sorting: 'Date',
    sortDirection: SortDirection.Desc,
  },
};

export default initStore;
